import { ReminderSettingModel } from "./reminder-setting-model";

export class ReminderSettingsData {
  annualStatementPaymentSetting: ReminderSettingModel;
  companyDebtSetting: ReminderSettingModel;
  asicFormSigningSetting: ReminderSettingModel;
  annualStatementSigningSetting: ReminderSettingModel;

  constructor(data: Partial<ReminderSettingsData> = {}) {
    this.annualStatementPaymentSetting = data.annualStatementPaymentSetting ?? new ReminderSettingModel();
    this.companyDebtSetting = data.companyDebtSetting ?? new ReminderSettingModel();
    this.asicFormSigningSetting = data.asicFormSigningSetting ?? new ReminderSettingModel();
    this.annualStatementSigningSetting = data.annualStatementSigningSetting ?? new ReminderSettingModel();
  }
}



